import { NgModule } from "@angular/core";
import { ColorPicker } from './ui/color-picker';
import { NotesComponent } from './ui/notes';
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms';
// import { AngularDraggableModule } from 'angular2-draggable';
import { PostItService } from './postIt.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        // AngularDraggableModule
    ],
    declarations: [
        ColorPicker,
        NotesComponent
    ],
    providers: [PostItService],
    exports: [
        ColorPicker,
        NotesComponent
    ]
})
export class PostItModule { }